import { render, staticRenderFns } from "./NamelistHostStudentDetailForm.vue?vue&type=template&id=f85f0f26&"
import script from "./NamelistHostStudentDetailForm.vue?vue&type=script&lang=js&"
export * from "./NamelistHostStudentDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports